/**
 * useCreateTicket Hook
 * Mutation for creating tickets
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import { TicketCreate, TicketDetail } from '@/types';
import { toast } from 'sonner';
import { formatAPIError } from '@/utils/errorHandlers';

export function useCreateTicket(projectId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ticket: TicketCreate) => {
      const { data } = await apiClient.post<TicketDetail>(
        `/projects/${projectId}/tickets`,
        ticket
      );
      return data;
    },
    onSuccess: (data) => {
      // Invalidate ticket lists
      queryClient.invalidateQueries({ queryKey: queryKeys.tickets.lists() });
      toast.success(`Ticket ${data.ticket_key} created successfully`);
    },
    onError: (error: any) => {
      const message = formatAPIError(error, 'Failed to create ticket');
      toast.error(message);
    },
  });
}
